export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: BlogCategory;
  author: {
    name: string;
    avatar: string;
    role: string;
  };
  publishedAt: string;
  readTime: number;
  featuredImage: string;
  tags: string[];
  featured?: boolean;
}

export type BlogCategory = 
  | 'HVAC Tips'
  | 'Plumbing Guides'
  | 'Electrical Safety'
  | 'Carpentry Tricks'
  | 'Business Tips'
  | 'Industry News';

export const BLOG_CATEGORIES: BlogCategory[] = [
  'HVAC Tips',
  'Plumbing Guides',
  'Electrical Safety',
  'Carpentry Tricks',
  'Business Tips',
  'Industry News'
];
